const ENTITY_TYPES_TABLE_READY = "entity-types-table-ready"
const SEARCH_TEXT_STATE = "entity-types-table-search-text-state"
const ROWS_PER_PAGE_STATE = "entity-types-table-rows-per-page-state"
const PAGINATION_STATE = "entity-types-table-pagination-state"

const ENTITY_TYPES_ID_FOR_ACTION = "entity-types-table-brand-id-for-action"


const ADDEDIT_DEPARTMENT_READY = "entity-types-table-addedit-entity-types-ready"

const initialState = {
    isEntityTypesTableReady: true,
    isAddEditEntityTypeReady: true,
    entityTypes: {},

    
    entityTypesSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case ENTITY_TYPES_TABLE_READY:
            return Object.assign({}, state, { isEntityTypesTableReady: action.payload })

        case ADDEDIT_DEPARTMENT_READY:
            return Object.assign({}, state, { isAddEditEntityTypeReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case ENTITY_TYPES_ID_FOR_ACTION:
            return Object.assign({}, state, {entityTypesSelectedId:action.payload})

        default:
        return state
    
    }

}

export function entityTypesTableReady(data) {
    return {
        type: ENTITY_TYPES_TABLE_READY,
        payload: data
    }
}

export function addEditEntityTypeReady(data) {
    return {
        type: ADDEDIT_DEPARTMENT_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function entityTypesIdForAction(entityTypesId){
    return{
        type:ENTITY_TYPES_ID_FOR_ACTION,
        payload:entityTypesId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Entity Types/redux/entity_types.js